import { createSlice } from '@reduxjs/toolkit';
import getAdapter from '../getAdapter';

const ownerTypesAdapter = getAdapter({ idFieldName: 'value' });

const ownerTypesSlice = createSlice({
  name: 'ownerTypes',
  initialState: ownerTypesAdapter.getInitialState(),
  reducers: {
    setOwnerTypes: (state, { payload: { ownerTypes } }) => {
      ownerTypesAdapter.setAll(state, ownerTypes);
    }
  }
});

const selectors = ownerTypesAdapter.getSelectors(({ ownerTypes }) => ownerTypes);

export const getAllOwnerTypes = state => selectors.selectAll(state);

export const { setOwnerTypes } = ownerTypesSlice.actions;

export default ownerTypesSlice.reducer;
